module.exports = __webpack_public_path__ + "static/pic02-9ec295af1e61a2150c3c03a618893186.jpg";